import { HrtApiService } from '../hrt-api/hrt-api.service';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemHealthModel } from '@shared/models';
import { DEFAULT_DATE_RANGE } from '@shared/helpers';

@Injectable({
  providedIn: 'root',
})
export class SystemHealthApiService {
  readonly api = inject(HrtApiService);

  getHealthCheck(machine: number, dateRange = DEFAULT_DATE_RANGE): Observable<SystemHealthModel> {
    return this.api.getForOrganization<SystemHealthModel>(`machines/${machine}/health-checks`, {
      params: { machine, dateRange },
    });
  }
}
